/**
 * Card Component Registration
 * This file registers all card components with the card registry
 *
 * Call this during app initialization (in main.tsx or App.tsx):
 *
 *   import { registerAllCardComponents } from '@/lib/cardSetup';
 *   registerAllCardComponents();
 */

import { registerProfileCardComponents } from '@/components/profile-cards';
import { registerDashboardCardComponents } from '@/components/dashboard-cards';
import { registerUsersCardComponents } from '@/components/users-cards';
import { registerUserDetailCardComponents } from '@/components/user-detail-cards';
import { registerOrganisationCardComponents } from '@/components/organisation-cards';

/**
 * Register all available card components
 * Must be called before rendering any pages with cards
 */
export function registerAllCardComponents() {
  console.debug('[Cards] Registering framework components...');

  registerProfileCardComponents();
  console.debug('[Cards] ✓ Profile cards registered');

  registerDashboardCardComponents();
  console.debug('[Cards] ✓ Dashboard cards registered');

  registerUsersCardComponents();
  console.debug('[Cards] ✓ Users cards registered');

  registerUserDetailCardComponents();
  console.debug('[Cards] ✓ User detail cards registered');

  registerOrganisationCardComponents();
  console.debug('[Cards] ✓ Organisation cards registered');

  console.debug('[Cards] All components ready');
}

export {
  registerProfileCardComponents,
  registerDashboardCardComponents,
  registerUsersCardComponents,
  registerUserDetailCardComponents,
  registerOrganisationCardComponents,
};
